import { render, staticRenderFns } from "./PointRuleList.vue?vue&type=template&id=17c53ac9&"
import script from "./PointRuleList.vue?vue&type=script&lang=js&"
export * from "./PointRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports